import { LoadableAfterPaint } from '@confluence/loadable';

// Renderer-specific exports
export { getRendererInlineCommentOptions } from './renderer/getRendererInlineCommentOptions';
export { SelectionComponent, type SelectionComponentProps } from './renderer/SelectionComponent';
export { ViewComponent, type ViewComponentProps } from './renderer/ViewComponent';
export { HoverComponent, type HoverComponentProps } from './renderer/HoverComponent';

// Editor-specific exports
export const EditorCreateComponent = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CreateComponent" */ './editor/CreateComponent'))
			.CreateComponent,
});

export const EditorViewComponent = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewComponent" */ './editor/ViewComponent'))
			.ViewComponent,
});
